'use client';

import { UOM } from 'constants/common';
import { useTranslations } from 'next-intl';
import { Conditional } from '@cat-ecom/pcc-components';
import MeasureUnitSelectorBody from './measure-unit-selector-body';
import ShortenedMeasureUnitSelectorBody from './shortened-measure-unit-selector-body';
import { LONG_TEXT_LANGUAGES } from '../constants';

const MeasureUnitSelector = ({
  defaultUom,
  onChangeUom,
  locale
}: {
  defaultUom: string;
  onChangeUom: (uomValue: string) => void;
  locale: string;
}) => {
  const t = useTranslations();
  const activeIndex = defaultUom === UOM.us ? 0 : 1;
  const shouldRenderRegularUOM = locale !== LONG_TEXT_LANGUAGES.ru;

  const uomData = [
    {
      unit: UOM.us,
      translation: t('UOMINCH'),
      testId: 'us'
    },
    { unit: UOM.metric, translation: t('UOMMETRIC'), testId: 'metric' }
  ];
  const commonProps = { activeIndex, onChangeUom, uomData };

  return (
    <Conditional
      test={shouldRenderRegularUOM}
      fallback={<ShortenedMeasureUnitSelectorBody {...commonProps} />}
    >
      <MeasureUnitSelectorBody {...commonProps} />
    </Conditional>
  );
};

export default MeasureUnitSelector;
